/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { LayoutTextWindowReverse, Search, QuestionCircle, ClipboardData, Receipt /*CardChecklist*/ } from "react-bootstrap-icons";

// import SVG from "react-inlinesvg";
import { /*toAbsoluteUrl,*/ checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>

        {/* Dashboard */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Brush.svg")} /> */}
            <LayoutTextWindowReverse/>
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Receipt Management */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/receipt-management", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/receipt-management">
            <span className="svg-icon menu-icon">
            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Pen-tool-vector.svg")} /> */}
            <Receipt/>
            </span>
            <span className="menu-text">Receipt Management</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Receipt Tracking */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/receipt-tracking", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/receipt-tracking">
            <span className="svg-icon menu-icon">
            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Pencil.svg")} /> */}
            <Search/>
            </span>
            <span className="menu-text">Receipt Tracking</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Refund Validation */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/refund-validation", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/refund-validation">
            <span className="svg-icon menu-icon">
            <CardChecklist/>
            </span>
            <span className="menu-text">Refund Validation</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Reporting */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/reporting", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/reporting">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Option.svg")} /> */}
              <ClipboardData/>
            </span>
            <span className="menu-text">Report Management</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Help */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/help", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/help">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Question-circle.svg")} /> */}
              <QuestionCircle/>
            </span>
            <span className="menu-text">Help</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
